<template>
  <div class="header" id="header" :class="{ 'hide': isHeaderHidden }">
    <div class="flex-between-center tab">
      <img class="header-logo" src="/static/img/logo.png" @click="goIndex"/>
      <div class="language flex-center">
        <p :style="selectedLanguage == 'zh' ? '' : 'opacity: 0.6;'" @click="change('zh')">中文</p>
        <p class="separate"/>
        <p :style="selectedLanguage == 'en' ? '' : 'opacity: 0.6;'" @click="change('en')">EN</p>
        <p class="separate"/>
        <div v-if="!showMenu" class="flex-col justify-between menu-tab" @click="menu">
          <div v-for="i in 3" :key="i" class="menu-line"/>
        </div>
        <div v-else class="flex-col justify-between menu-tab" @click="menu">
          <div v-for="i in 2" :key="i" class="menu-cross"/>
        </div>
      </div>
    </div>

    <ul class="menu flex-col align-center" v-show="showMenu" @click="menu">
      <router-link tag="li" to="/home/index">{{$t("menu.l1")}}</router-link>
      <router-link tag="li" to="/home/about">{{$t("menu.l2")}}</router-link>

      <!-- 裕林科技板 二级菜单 -->
      <li class="scene-menu-item" @click.stop="toggleSceneMenu">
        <span class="mobile-menu-main-text">
          {{$t("menu.l3")}}
          <span class="mobile-menu-badge new">NEW</span>
        </span>
        <i class="el-icon-arrow-down" :class="{ 'rotate': sceneMenuOpen }"></i>
        
        <!-- 移动端场景二级菜单 -->
        <transition name="mobile-menu-slide">
          <div class="mobile-scene-menu" v-show="sceneMenuOpen">
            <div class="mobile-scene-menu-content">
              <router-link
                v-for="(item, index) in sceneItems"
                :key="item.id"
                :to="getSceneRoute(item.index)"
                class="mobile-scene-menu-item"
                :class="{ 'first-item': index === 0, 'last-item': index === sceneItems.length - 1 }"
                @click.native="closeAllMenus">
                <div class="mobile-menu-item-content">
                  <div class="mobile-menu-item-icon" :class="item.iconClass">
                    <span>{{ item.icon }}</span>
                  </div>
                  <div class="mobile-menu-text-wrapper">
                    <span class="mobile-scene-menu-name">
                      {{ selectedLanguage == 'zh' ? item.nameZh : item.nameEn }}
                    </span>
                    <span class="mobile-menu-desc">
                      {{ selectedLanguage == 'zh' ? item.descZh : item.descEn }}
                    </span>
                    <div class="mobile-item-badge" :class="item.badge" v-if="item.badge">
                        {{ item.badge }}
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </transition>
      </li>

      <!-- 产品定制中心 二级菜单 -->
      <li class="product-menu-item" @click.stop="toggleProductMenu">
        <span>{{$t("menu.l4")}}</span>
        <i class="el-icon-arrow-down" :class="{ 'rotate': productMenuOpen }"></i>
        
        <!-- 移动端大背景图二级菜单 -->
        <transition name="mobile-menu-slide">
          <div class="mobile-mega-menu" v-show="productMenuOpen">
            <div class="mobile-mega-menu-grid">
              <router-link
                v-for="item in menuItems"
                :key="item.command"
                :to="getRoute(item.command)"
                class="mobile-mega-menu-item"
                :style="{ backgroundImage: 'url(' + item.bgImage + ')' }"
                @click.native="closeAllMenus">
                <div class="mobile-mega-menu-overlay"/>
                <span class="mobile-mega-menu-name">
                  {{ selectedLanguage == 'zh' ? item.nameZh : item.nameEn }}
                </span>
              </router-link>
            </div>
          </div>
        </transition>
      </li>

      <router-link tag="li" to="/home/news">{{$t("menu.l6")}}</router-link>
      <router-link tag="li" to="/home/join">{{$t("menu.l7")}}</router-link>
    </ul>
  </div>
</template>

<script>
  import pubsub from 'pubsub-js'
  import product from '@/assets/json/product.json'

  import { setup } from "../../locales"

  export default {
    data() {
      return {
        selectedLanguage: localStorage.getItem('lindemanLocaleLanguage') ? localStorage.getItem('lindemanLocaleLanguage') : 'zh',

        isHeaderHidden: false,
        lastScrollPosition: 0,

        showMenu: false,
        sceneMenuOpen: false,
        productMenuOpen: false,
        menuItems: product.menuItems,

        // 应用场景菜单数据 - 与PC端同步
        sceneItems: [
          {
            index: 0,
            nameZh: '房车应用',
            nameEn: 'RV Application',
            descZh: '专业房车解决方案',
            descEn: 'Professional RV Solutions',
            icon: '🚐',
            iconClass: 'icon-rv-bg',
            badge: 'hot'
          },
          {
            index: 1, 
            nameZh: '家居定制',
            nameEn: 'Home Customization',
            descZh: '个性化家居定制',
            descEn: 'Personalized Home Solutions',
            icon: '🏠',
            iconClass: 'icon-home-bg',
            badge: 'new'
          }
        ]
      }
    },

    mounted() {
      setup(this.selectedLanguage)

      // 上下滚动滑屏展示或隐藏导航栏
      window.addEventListener('scroll', this.handleScroll)
    },

    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll)
    },

    methods: {
      // 跳转首页
      goIndex(){
        this.$router.push({
          path: 'index',
          query: {
            key: Math.random()
          }
        })
      },

      change(language){
        this.selectedLanguage = language
        setup(language)
        pubsub.publish('lindemanLocaleLanguage', language)
      },

      menu(){
        this.showMenu = !this.showMenu
        if (!this.showMenu) {
          this.sceneMenuOpen = false
          this.productMenuOpen = false
        }
      },
      
      toggleSceneMenu() {
        this.sceneMenuOpen = !this.sceneMenuOpen
        // 关闭其他菜单
        if (this.sceneMenuOpen) {
          this.productMenuOpen = false
        }
      },
      
      toggleProductMenu() {
        this.productMenuOpen = !this.productMenuOpen
        // 关闭其他菜单
        if (this.productMenuOpen) {
          this.sceneMenuOpen = false
        }
      },
      
      closeAllMenus() {
        this.showMenu = false
        this.sceneMenuOpen = false
        this.productMenuOpen = false
      },

      // 裕林科技板应用场景路由
      getSceneRoute(sceneIndex) {
        return `/home/yulin/${sceneIndex}`
      },

      // 产品定制中心路由
      getRoute(spaceIndex) {
        return `/home/product?spaceIndex=${spaceIndex}&key=${Math.random()}`
      },

      handleScroll() {
        const current = window.pageYOffset
      
        // 向下滚动超过50px时隐藏
        if (current > this.lastScrollPosition && current > 50) {
          this.isHeaderHidden = true
        } 
        // 向上滚动时显示
        else if (current < this.lastScrollPosition) {
          this.isHeaderHidden = false
        }
        
        this.lastScrollPosition = current
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../static/css/mobile/header.scss';

  /* 菜单项通用样式 */
  .scene-menu-item,
  .product-menu-item {
    position: relative;
    width: 100%;
    padding: 15px 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    
    i {
      margin-left: 5px;
      transition: transform 0.3s;
      
      &.rotate {
        transform: rotate(180deg);
      }
    }
  }

  .mobile-menu-main-text {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-weight: 500;
    position: relative;
    padding: 0 8px;
  }

  /* 移动端菜单角标样式 */
  .mobile-menu-badge {
    position: absolute;
    top: 8px;
    right: -32px;
    font-size: 10px;
    padding: 2px 6px;
    border-radius: 8px;
    font-weight: 700;
    line-height: 1;
    background-color: #667eea;
    color: white;
    transform: scale(0.8);
  }
  
  /* 移动端场景二级菜单 */
  .mobile-scene-menu {
    width: 100%;
    background: white;
    z-index: 100;
    box-sizing: border-box;
  }
  
  .mobile-scene-menu-content {
    display: flex;
    flex-direction: column; /* 改为垂直布局 */
    width: 100%;
  }
  
  .mobile-scene-menu-item {
    display: block;
    text-decoration: none;
    color: #2d3748;
    transition: all 0.3s ease;
    width: 100%;
    box-sizing: border-box;
  }
  
  .mobile-menu-item-content {
    display: flex;
    justify-content: center;
    padding: 16px 20px;
    transition: all 0.3s ease;
    position: relative;
    width: 100%;
    box-sizing: border-box;
    min-height: 80px; /* 设置最小高度 */
  }
  
  .mobile-scene-menu-item:hover .mobile-menu-item-content {
    background: linear-gradient(135deg, #f8faff 0%, #f9f5ff 100%);
  }
  
  .mobile-menu-item-icon {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    transition: all 0.3s ease;
    margin-right: 10px;
  }
  
  .icon-rv-bg {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  }
  
  .icon-home-bg {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  }
  
  .mobile-menu-text-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: start;
    min-width: 0; /* 重要：防止文本溢出 */
    overflow: hidden; /* 隐藏溢出内容 */
  }
  
  .mobile-scene-menu-name {
    font-size: 14px;
    font-weight: 600;
    color: #2d3748;
    line-height: 1.3;
    margin-bottom: 4px;
    word-wrap: break-word;
    overflow-wrap: break-word;
    word-break: break-word; /* 确保长单词也能换行 */
  }
  
  .mobile-menu-desc {
    font-size: 12px;
    color: #718096;
    line-height: 1.4;
    word-wrap: break-word;
    overflow-wrap: break-word;
    word-break: break-word; /* 确保长单词也能换行 */
  }
  
  /* 移动端下拉菜单项角标样式 */
  .mobile-item-badge {
    position: absolute;
    top: 25px;
    right: 40px;
    font-size: 10px;
    padding: 3px 6px;
    border-radius: 8px;
    font-weight: 700;
    line-height: 1;
    color: white;
    z-index: 2;
  }
  
  .mobile-item-badge.hot {
    background: 
      radial-gradient(circle at 30% 30%, #ff6b6b 0%, #ee5a52 100%),
      url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="%23ffffff" opacity="0.3"/><circle cx="12" cy="12" r="6" fill="%23ffffff" opacity="0.5"/><circle cx="12" cy="12" r="3" fill="%23ffffff" opacity="0.7"/></svg>') no-repeat center;
    background-size: cover, 12px 12px;
    background-blend-mode: overlay;
    box-shadow: 0 2px 4px rgba(238, 90, 82, 0.3);
  }
  
  .mobile-item-badge.new {
    background: 
      radial-gradient(circle at 30% 30%, #4ecdc4 0%, #44a08d 100%),
      url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="%23ffffff" opacity="0.3"/><circle cx="12" cy="12" r="6" fill="%23ffffff" opacity="0.5"/><circle cx="12" cy="12" r="3" fill="%23ffffff" opacity="0.7"/></svg>') no-repeat center;
    background-size: cover, 12px 12px;
    background-blend-mode: overlay;
    box-shadow: 0 2px 4px rgba(68, 160, 141, 0.3);
  }
  
  /* 移动端大背景图菜单 */
  .mobile-mega-menu {
    width: 100%;
    padding: 10px;
    background: white;
    z-index: 100;
  }
  
  .mobile-mega-menu-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }
  
  .mobile-mega-menu-item {
    width: 100%;
    aspect-ratio: 16/9;
    background-size: cover;
    background-position: center;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
    display: block;
  }
  
  .mobile-mega-menu-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 50%, rgba(0,0,0,0) 100%);
  }
  
  .mobile-mega-menu-name {
    position: absolute;
    bottom: 10px;
    left: 0;
    width: 100%;
    text-align: center;
    color: white;
    font-size: 14px;
    padding: 0 5px;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
  }
  
  /* 移动端过渡动画 */
  .mobile-menu-slide-enter-active {
    transition: all 0.3s ease;
  }
  
  .mobile-menu-slide-leave-active {
    transition: all 0.2s ease;
  }
  
  .mobile-menu-slide-enter-from {
    opacity: 0;
    transform: translateY(-10px);
  }
  
  .mobile-menu-slide-leave-to {
    opacity: 0;
    transform: translateY(-5px);
  }
</style>


// WEBPACK FOOTER //
// src/components/mobile/Header.vue